import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'admin-users-list',
    templateUrl: 'admin-users-list.page.html',
    styleUrls: ['../../../../layouts/admin/admin.layout.scss', 'admin-users-list.page.scss'],
})
export class AdminUsersListPage implements OnInit {
    ngOnInit(): void {

    }
}